import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {DataService} from '../../../../Services/data.service';

@Component({
  selector: 'app-wo-items-tab',
  templateUrl: './wo-items-tab.component.html',
  standalone: false,
})
export class WoItemsTabComponent implements OnInit, OnChanges {
  @Input() headerId: string | null = null;
  @Input() readonly = false;

  rows: any[] = [];
  items: any[] = [];
  isLoaded = false;

  constructor(
    private woService: WorkOrderService,
    private dataService: DataService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
  ) {
  }

  ngOnInit(): void {
    this.loadItems();
    this.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headerId'] && !changes['headerId'].firstChange) {
      this.load();
    }
  }

  loadItems(): void {
    this.dataService.getData('item', '?pageNumber=0&pageSize=999999').subscribe({
      next: (res: any) => {
        this.items = res?.Data ?? res?.data ?? res ?? [];
      },
      error: () => {
      }
    });
  }

  load(): void {
    if (!this.headerId) {
      this.isLoaded = true;
      return;
    }
    this.woService.getWorkOrder(this.headerId).subscribe({
      next: (res: any) => {
        this.rows = (res?.wo_items ?? []).map((r: any) => ({
          ...r,
          // Use server-returned description/name if present; avoids needing items[] for display
          description: r.description ?? r.item_name ?? ''
        }));
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  addRow(): void {
    this.rows.push({
      id: null,
      header_id: this.headerId,
      item_id: null,
      description: '',
      quantity: 1,
      unit_price: 0,
      unit_cost: null,
      billable: true,
      invoice_detail_id: null,
      sort_order: (this.rows.length + 1) * 10,
    });
  }

  onItemSelect(row: any): void {
    const found = this.items.find((i: any) => i.id === row.item_id);
    if (found) {
      row.description = found.name ?? found.description ?? '';
      row.unit_price = found.price ?? found.unit_price ?? 0;
      row.unit_cost = found.cost ?? found.unit_cost ?? null;
    }
  }

  removeRow(index: number): void {
    const row = this.rows[index];
    if (row.invoice_detail_id) {
      this.notification.showWarningToast('This line has been invoiced and cannot be deleted.');
      return;
    }
    this.confirmDialog.confirmThis(
      ['Delete this materials entry?'],
      () => {
        this.rows.splice(index, 1);
      },
      () => {
      }
    );
  }

  save(): void {
    if (!this.headerId) {
      return;
    }
    const body = {wo_header: {}, wo_items: this.rows};
    console.log('[WO Items Save] PATCH api/WorkOrder/' + this.headerId, body);
    this.woService.updateWorkOrder(this.headerId, body).subscribe({
      next: () => {
        this.notification.showSuccessToast('Materials saved.');
        this.load();
      },
      error: () => {
        this.notification.showErrorToast('Error saving materials.');
      }
    });
  }

  lineTotal(row: any): number {
    return Math.round((row.quantity || 0) * (row.unit_price || 0) * 100) / 100;
  }
}
